<template>
    <span>{{formattedNumber}}</span>
</template>

<script>
import { numberCommaFormat } from "@js/helpers.ts";

export default {
    name: "NumberFormatComponent",
    props: {
        number: {
            type: [Number, String],
            required: true,
        },
        append_text: {
            type: [Number, String],
            default: '',
        },
    },
    computed: {
        formattedNumber() {
            // Если number невалиден — вернём "-"
            if (this.number === null || this.number === undefined || this.number === '') {
                return '0' + this.append_text;
            }

            return numberCommaFormat(this.number) + this.append_text;
        },
    },
}
</script>

<style scoped></style>
